import React from 'react';
import { Provider } from "react-redux";
import { createRoot } from 'react-dom/client';
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import store, { history } from "./store.jsx";

import {configure} from 'react-hotkeys';

import Application from 'pages/application';

import 'index.css';

import AuthInterceptor from './services/auth.interceptor.js';

import reportWebVitals from './reportWebVitals';

import 'bootstrap/dist/css/bootstrap.min.css';
import '@paperflite-marketing/cleverstory-commons/dist/index.css';

new AuthInterceptor(history);

configure({
  ignoreRepeatedEventsWhenKeyHeldDown: false,
  stopEventPropagationAfterHandling: false,
  stopEventPropagationAfterIgnoring: false
});

// Concurrent rendering mode
const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <DndProvider backend={HTML5Backend}>
      <Application />
    </DndProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();